import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { DenyBusinessUserGuard } from 'src/app/deny-business-user.guard';

export function withDefaultAppGuards(routes: Routes) {
  for (let route of routes) {
    if (route.children) {
      withDefaultAppGuards(route.children);
    }

    if (route.redirectTo) {
      continue;
    }

    if (route.data?.auth !== false) {
      route.canActivate = [AuthGuard, ...(route.canActivate ?? [])];
    
      if (route.data?.allowBusinessUsers !== true) {
        route.canActivate = [DenyBusinessUserGuard, ...(route.canActivate ?? [])];
      }
    }
  }

  return routes;
}
